/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class AuthRepo {
    
    constructor($auth){
        $http = new Http($auth);        
    }            
    
    forgotPassword(data){            
        return $http.post("forgot/password", data).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    } 
       
    passwordReset(data){            
        return $http.post("password/reset", data).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }   
    
    confirmEmail(token){            
        return $http.get("email/confirmation/" + token).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }        
   
}


// WEBPACK FOOTER //
// ./src/repos/AuthRepo.js